import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useStyles } from "./LoginInfo.css";

class LoginInfo extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.paper}>
        <div style={{ fontSize: 20 }}>{this.props.options.description}</div>
        <br />
        <div className={classes.listStyle}>
          <Avatar className={classes.avatarStyle}>
            <img
              src={this.props.options.feature1.icon}
              style={{ width: 70, height: 70 }}
              alt="Rent Book"
            />
          </Avatar>
          <div>{this.props.options.feature1.details}</div>
        </div>
        <br />
        <div className={classes.listStyle}>
          <div>{this.props.options.feature2.details}</div>
          <Avatar className={classes.avatarStyle}>
            <img
              src={this.props.options.feature2.icon}
              style={{ width: 70, height: 70 }}
              alt="Rent Book"
            />
          </Avatar>
        </div>
        <br />
        <div className={classes.linkStyle}>
          <ArrowBackIcon />
          <Link to="/" style={{ textDecoration: "none" }}>
            Go to Home
          </Link>
        </div>
      </Paper>
    );
  }
}

export default withStyles(useStyles)(LoginInfo);
